import { render } from "./CollectionSection.vue?vue&type=template&id=7b6bf977"
import script from "./CollectionSection.vue?vue&type=script&lang=js"
export * from "./CollectionSection.vue?vue&type=script&lang=js"

import "./CollectionSection.vue?vue&type=style&index=0&id=7b6bf977&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__